<template>
  <b-card class="setting-menu" no-body>
    <b-card-body>
      <b-card-title class="dark-variant text-align">Settings</b-card-title>
      <ul>
        <li>
          <router-link to="/app/profile" tag="li">
            <span>Profile</span>
          </router-link>
        </li>
        <li>
          <router-link to="/app/security" tag="li">
            <span>Security</span>
          </router-link>
        </li>
        <li>
          <router-link to="/app/bank" tag="li">
            <span>Bank</span>
          </router-link>
        </li>
        <li>
          <router-link to="/app/kyc" tag="li">
            <span>KYC</span>
          </router-link>
        </li>
        <li>
          <router-link to="/app/qr-code" tag="li">
            <span>QR Code</span>
          </router-link>
        </li>
        <li>
          <router-link to="/app/mpin" tag="li">
            <span>MPIN</span>
          </router-link>
        </li>
        <li>
          <router-link to="/app/account" tag="li">
            <span>Account</span>
          </router-link>
        </li>
      </ul>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  name: "SettingsMenu",
};
</script>
<style lang="scss">
  @import '../../css/style.scss';
</style>

<style scoped>
/* The active pill sets colour on the <a>, but the label lives in a <span>
   that inherited the dark link colour - force it white. */
.setting-menu ul li >>> .router-link-active,
.setting-menu ul li >>> .router-link-exact-active {
  background: #0067b2;
  color: #fff !important;
  border-radius: 4px;
  display: block;
}
.setting-menu ul li >>> .router-link-active span,
.setting-menu ul li >>> .router-link-exact-active span {
  color: #fff !important;
}
.setting-menu ul li:hover >>> a,
.setting-menu ul li:hover >>> a span {
  color: #fff !important;
}
</style>
